import { toneClass } from "@/modules/shared/status";
import { parseDeliveredFilesInternalNote } from "@/modules/tickets/parseDeliveredFilesInternalNote";

export const TicketDeliveredFilesNoteCard = ({
  body,
}: {
  body?: string | null;
}) => {
  const note = parseDeliveredFilesInternalNote(body);
  if (!note) return null;

  return (
    <div className="mt-2 border-l-2 border-warning/70 pl-2.5">
      <div className="min-w-0">
        <div className="flex flex-wrap items-baseline gap-x-1.5 gap-y-0.5">
          <span className="text-sm font-semibold text-foreground">
            Files delivered
          </span>
          {note.invoiceNumber ? (
            <span className="font-mono text-2xs text-muted-foreground">
              {note.invoiceNumber}
            </span>
          ) : null}
        </div>

        {note.delivered ? (
          <p className="mt-0.5 text-2xs leading-4 text-muted-foreground">
            {note.delivered}
          </p>
        ) : null}

        {note.property ? (
          <p className="mt-0.5 truncate text-2xs leading-4 text-foreground">
            {note.property}
          </p>
        ) : null}

        {note.resolved ? (
          <p
            className={`mt-0.5 text-2xs leading-4 ${toneClass("warning", "text")}`}
          >
            Ticket marked resolved
          </p>
        ) : null}
      </div>
    </div>
  );
};
